/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Cookie from 'js-cookie';
import { addCommasToMoney } from '../../helper/index';

/**
 * @class UserOnTrackSavings
 */
class UserOnTrackSavings extends React.Component {

  /**
   *
   * @param {*} id
   * @param {*} planType
   * @returns {*} - state
   */
  onClickUserSavings = (id, planType) => {
    const savingObj = {
      id,
      planType
    };
    Cookie.set('savingObj', savingObj);
    Cookie.set('savingId', id);
    Cookie.set('planType', planType);
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      title,
      planType,
      amountSaved,
      amountAccrued,
      totalInterestEarned,
      id,
    } = this.props;


    const mainAmount = amountSaved === 0 ? 0 : addCommasToMoney(amountSaved);

    const contributionAmount = amountAccrued === 0 ? 0 : addCommasToMoney(amountAccrued);

    const formatTotalEarned = totalInterestEarned === 0 ? 0 : addCommasToMoney(totalInterestEarned);

    return (
      <div className="savings_plan_for_interest_options ontrack">
        <a href="/saving-details"
          style={{ textDecoration: 'none' }}
          onClick={() => this.onClickUserSavings(id, planType)}
        >
          <div className="header">
            <h5>
              {title}
            </h5>
          </div>
          <div className="savings_breakdown_interest">

            <div>
              <span>
                {planType}
              </span>
              <p>
                {`₦ ${mainAmount}`}
              </p>
            </div>
            <div>
              <span>
                    Contribution
              </span>
              <p>
                {`₦ ${contributionAmount}`}
              </p>
            </div>
            <div>
              <span>
                    Interest
              </span>
              <p>
                {`₦ ${formatTotalEarned}`}
              </p>
            </div>
          </div>
          <div className="savings_interest_progress">
            <div className="savings_progresss_text">
              <div>
                <span />
                    
              </div>
            </div>
            <div className="progress">
              <div className="progress-bar" style={{ width: '70%' }} />
            </div>
          </div>
        </a>
      </div>
    );
  }
}

UserOnTrackSavings.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  planType: PropTypes.string,
  amountSaved: PropTypes.any,
  amountAccrued: PropTypes.any,
  totalInterestEarned: PropTypes.any
};

export default UserOnTrackSavings;
